<div class="irrigation-chart-container">
  <span class="field-analysis-header">Irrigation Chart</span>
  <!-- Where the weather lines come from. No line while the station is unknown, so a failed
       context call never reads as "no station linked". -->
  <span *ngIf="weatherLabel()" class="block text-sm text-[var(--tertiary-text)]">{{ weatherLabel() }}</span>
  <!-- <p class="chart-subtitle">
    Sum of HC Air temperature (°C) max. Sum of ET0 (mm).<br>
    Sum of Precipitation (mm). Earliest starttime.<br>
    Sum of qty given_time by Date and starttime.
  </p> -->
  <div echarts [options]="chartOption" [merge]="chartOption" [autoResize]="true" style="height: 400px; width: 100%; max-width: 100%;"></div>
  <div echarts [options]="summaryChartOption" [merge]="summaryChartOption" [autoResize]="true" style="height: 120px; width: 100%; max-width: 100%;"></div>
</div>
